import React from 'react';

import { isQuote } from 'utils/subcampaign';
import { __t, applyTranslations } from 'utils/language';
import { addThousandsSeparator } from 'utils/helper/common';
import { isOffer } from 'utils/offers/offers';

import './campaigns-table-influencer-budget-cell.scss';

applyTranslations(require('./i18n/campaigns-table-actions-cell.i18n.json'));

import type { CampaignWithSubcampaignMeta } from 'types';

type Props = {
  campaign: CampaignWithSubcampaignMeta
};

const CampaignsTableInfluencerBudgetCell = ({
  campaign
}: Props) => {
  const getBudgetRow = (label: string, value) => (
    <div className="campaigns-table-budget-cell__row">
      <div className="campaigns-table-influencer-budget-cell__label">{`${label}:`}</div>
      <div className="campaigns-table-influencer-budget-cell__value">{`${addThousandsSeparator(value)}€`}</div>
    </div>
  );

  if (!campaign.subcampaignMeta) {
    return null;
  }

  const offer = campaign.subcampaignMeta.offer;

  if (isQuote(campaign.subcampaignMeta) || !isOffer(campaign.subcampaignMeta)) {
    return (
      <div className="campaigns-table-influencer-budget-cell__value">
        {__t(`campaigns_table_actions_cell.influencer_budget_column_labels.${isQuote(campaign.subcampaignMeta) ? 'quote' : 'other_arrangement'}`)}
      </div>
    );
  }

  return (
    <div className="campaigns-table-budget-cell">
      <div className="campaigns-table-influencer-budget-cell__monetary">
        {offer.budget &&
          getBudgetRow(__t('campaigns_table_actions_cell.influencer_budget_column_labels.budget'), offer.budget)}
        {campaign.subcampaignMeta.variablePaymentsSum &&
          getBudgetRow(__t('campaigns_table_actions_cell.influencer_budget_column_labels.variable'), campaign.subcampaignMeta.variablePaymentsSum)}
      </div>
      <div className="campaigns-table-influencer-budget-cell__voucher">
        {offer.additionalCompensation?.voucherAmount &&
            getBudgetRow(__t('campaigns_table_actions_cell.influencer_budget_column_labels.voucher'), offer.additionalCompensation.voucherAmount)}
        {
          offer.additionalCompensation?.otherDescription && (
            <span className="campaigns-table-influencer-budget-cell__value">
              {__t('campaigns_table_actions_cell.influencer_budget_column_labels.other_arrangement')}
            </span>
          )
        }
      </div>
    </div>
  );
};

export default CampaignsTableInfluencerBudgetCell;
